/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding initialization code.
 * Use "quasar new plugin <name>" and add it there.
 * One plugin per concern. Then reference the file(s) in quasar.conf.js > plugins:
 * plugins: ['file', ...] // do not add ".js" extension to it.
 **/



import 'quasar-extras/roboto-font/roboto-font.css'

import 'quasar-extras/material-icons/material-icons.css'




import 'quasar-app-styl'


import 'src/css/app.styl'


import Vue from 'vue'
import createApp from './app.js'




import pAxios from 'src/plugins/axios'

import pErrors from 'src/plugins/errors'

import pCrud from 'src/plugins/crud'

import pBreadcrumbs from 'src/plugins/breadcrumbs'

import pFilters from 'src/plugins/filters'

import pValidate from 'src/plugins/validate'

import pRoutes from 'src/plugins/routes'

import pModules from 'src/plugins/modules'

import pDownload from 'src/plugins/download'














const { app, store, router } = createApp()




;[pAxios,pErrors,pCrud,pBreadcrumbs,pFilters,pValidate,pRoutes,pModules,pDownload].forEach(plugin => {
  plugin({
    app,
    router,
    store,
    Vue,
    ssrContext: null
  })
})









new Vue(app)






